import React from 'react';

interface SliderInputProps {
    label: string;
    value: number;
    min: number;
    max: number;
    unit: string;
    onChange: (value: number) => void;
    disabled?: boolean;
}

const SliderInput: React.FC<SliderInputProps> = ({ label, value, min, max, unit, onChange, disabled }) => {
    const percentage = ((value - min) / (max - min)) * 100;

    return (
        <div className="slider-group">
            <label>{label}: {value}{unit}</label>
            <input
                type="range"
                min={min}
                max={max}
                value={value}
                onChange={(e) => onChange(parseInt(e.target.value))}
                className="slider"
                disabled={disabled}
                style={{
                    background: `linear-gradient(to right, #5493DA 0%, #5493DA ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`
                }}
            />
        </div>
    );
};

export default SliderInput;
